import React from 'react';

export default function CosmicBackground() {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      {/* Base gradient */}
      <div className="absolute inset-0 nebula-bg" />
      {/* Star field */}
      <div className="absolute inset-0 stars-bg opacity-60" />
      {/* Nebula blobs */}
      <div
        className="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] rounded-full opacity-10"
        style={{
          background: 'radial-gradient(circle, #6D28D9 0%, transparent 70%)',
          filter: 'blur(80px)',
        }}
      />
      <div
        className="absolute bottom-[-10%] left-[-15%] w-[500px] h-[500px] rounded-full opacity-8"
        style={{
          background: 'radial-gradient(circle, #4C1D95 0%, transparent 70%)',
          filter: 'blur(100px)',
        }}
      />
      <div
        className="absolute top-[40%] left-[30%] w-[300px] h-[300px] rounded-full opacity-5"
        style={{
          background: 'radial-gradient(circle, #FBBF24 0%, transparent 70%)',
          filter: 'blur(60px)',
        }}
      />
      {/* Floating star particles */}
      {[
        { top: '8%', left: '15%', size: 2, delay: 0 },
        { top: '15%', left: '75%', size: 1.5, delay: 1 },
        { top: '25%', left: '45%', size: 2.5, delay: 2 },
        { top: '60%', left: '10%', size: 1.5, delay: 0.5 },
        { top: '70%', left: '85%', size: 2, delay: 1.5 },
        { top: '85%', left: '55%', size: 1, delay: 2.5 },
        { top: '35%', left: '90%', size: 2, delay: 3 },
        { top: '50%', left: '25%', size: 1.5, delay: 1 },
      ]?.map((star, i) => (
        <div
          key={`star-particle-${i}`}
          className="absolute rounded-full bg-accent animate-twinkle"
          style={{
            top: star?.top,
            left: star?.left,
            width: `${star?.size}px`,
            height: `${star?.size}px`,
            animationDelay: `${star?.delay}s`,
            opacity: 0.4,
          }}
        />
      ))}
    </div>
  );
}